module.exports = __webpack_public_path__ + "media/student_v2/assets/images/input_validated-af0953245c5552080ba950820d2a96a9.svg";